export default "__VITE_ASSET__Dq2a_T5s__"